module.exports = __webpack_public_path__ + "img/play-filled.05483577.svg";